import axios from 'axios';

const API_BASE_URL =
    process.env.REACT_APP_API_URL ||
    'https://certichain-backend-ypxo.onrender.com/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (profileData) => api.put('/auth/profile', profileData),
  logout: () => api.post('/auth/logout'),
};

export const certificateAPI = {
  issue: (certificateData) => api.post('/certificates/issue', certificateData),
  getMyCertificates: () => api.get('/certificates/my-certificates'),
  getCertificateById: (id) => api.get(`/certificates/${id}`),
  getCertificateByApiCode: (code) => api.get(`/certificates/api-code/${code}`),
  getCollegeCertificates: (params) => api.get('/certificates/college/all', { params }),
  revokeCertificate: (id, reason) => api.put(`/certificates/${id}/revoke`, { reason }),
  batchIssue: (certificates) => api.post('/certificates/batch/issue', { certificates }),
};

export const verifyAPI = {
  verifyCertificateById: (id) => api.get(`/verify/certificate/${id}`),
  verifyCertificateByHash: (hash) => api.get(`/verify/hash/${hash}`),
  verifyByQRCode: (qrData) => api.post('/verify/qr-code', { qrData }),
  getVerificationStats: () => api.get('/verify/statistics'),
  batchVerify: (certificates) => api.post('/verify/batch', { certificates }),
};

export const blockchainAPI = {
  getNetworkInfo: () => api.get('/blockchain/network'),
  getContractInfo: () => api.get('/blockchain/contract'),
};

export default api;
